module.exports = __webpack_public_path__ + "static/media/rci_veranda_bedroom-790x592.40d9ab00.jpg";